import React from "react";
import "./assets/styles/global.css";
import Routes from "./routes";

const App: React.FC = () => {
  return <Routes />;
};

export default App;
